import { useEffect, useContext, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { ContentBody, ContentHeader } from 'components/shared/content'
import * as H from 'history'
import { ActionTableCell, CheckboxTableRow, ExTable, FixedFooter, TableBody, TableCell, TableHead, useMultipleCheckForm } from 'components/shared/widget'
import { TranscriptionHistory, TranscriptionHistorySearchForm, TranscriptionType } from 'entities/transcription_history'
import { useDeleteTranscriptionHistoryApi, useFetchTranscriptionHistoriesApi } from 'api/transcription_history'
import { transcriptionHistoryColumnInfoList, TranscriptionHistoryTableData } from './transcription_history_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { Button } from 'react-bootstrap'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { MasterDataContext } from 'contexts/master_data_context'
import { TranscriptionHistoryViewModel } from 'view_models/transcription_history_view_model'
import { Pagination } from 'components/shared/pagination'
import { Flex } from 'components/shared/flex'
import { EditTranscriptionHistoryForm } from './transciption_history_form'

type Props = {
    history: H.History
}

export type CheckShippingForm = {
    transcriptionHistoryId?: number
    freezerLocation?: string
    rackId?: string
    data?: string
    projectCode?: string
}

export type ShippingItem = {
    sampleId: number | null
    tubeLocation: string | null
}

export type ShippingForm = {
    transcriptionHistoryId?: number
    items?: ShippingItem[]
    freezerLocation?: string
    rackId?: string
    rackTypeId?: number
}

const TranscriptionHistoriesPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const masterData = useContext(MasterDataContext)
    const params = useQuery<{ type: TranscriptionType }>()
    const transcriptionHistoryDisplaySetting = useDisplaySetting(transcriptionHistoryColumnInfoList(), 'TranscriptionHistory')
    const deleteApi = useDeleteTranscriptionHistoryApi()
    const searchForm = useForm<TranscriptionHistorySearchForm>({ ...params, ordering: '-created_at', perPage: 20 })
    const listApi = useFetchTranscriptionHistoriesApi(searchForm)
    const [showEdit, setShowEdit] = useState<boolean>(false)
    const [selectedTranscriptionHistory, setSelectedTranscriptionHistory] = useState<TranscriptionHistory>({})
    const multipleCheckForm = useMultipleCheckForm()


    useEffect(() => {
        listApi.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(deleteApi.loading)
        if (deleteApi.isSuccess()) {
            listApi.execute()
        }
    }, [deleteApi.loading])

    return (
        <>
            <EditTranscriptionHistoryForm
                show={showEdit}
                transcriptionHistory={selectedTranscriptionHistory}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    setShowEdit(false)
                    listApi.execute()
                }}
            />
            <ContentHeader
                headerTitle={`${params.type} 転記履歴`}
                right={
                    <Flex alignItems="center">
                        <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                        <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {listApi.response.count.toLocaleString()}件</div>
                    </Flex>
                }
            />
            <ContentBody>
                <>
                    <ExTable>
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={listApi.response.results} multipleCheckForm={multipleCheckForm} showEdit>
                                <TableCell onClick={() => { }} th width={100} />
                                <TableCell onClick={() => { }} th width={100} />
                                <TableHeads displaySetting={transcriptionHistoryDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={listApi.loading}>
                            {listApi.response.results.map((transcriptionHistory: TranscriptionHistory) => {
                                return (
                                    <CheckboxTableRow key={transcriptionHistory.id} item={transcriptionHistory} multipleCheckForm={multipleCheckForm}>
                                        <ActionTableCell
                                            action={'edit'}
                                            onClick={() => {
                                                setSelectedTranscriptionHistory(transcriptionHistory)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <TableCell>
                                            <Button
                                                disabled={transcriptionHistory.isCompleted}
                                                variant="secondary"
                                                size="sm"
                                                onClick={(e) => {
                                                    globalState.showConfirm(
                                                        <div>
                                                            転記履歴を削除すると、転記した{transcriptionHistory.itemCount}件のデータも削除されます。<br></br>
                                                            本当に削除する場合は以下のフォームに「削除」と入力してOKを押してください<br></br>
                                                        </div>,
                                                        () => {
                                                            deleteApi.execute(transcriptionHistory.id!)
                                                        },
                                                        { confirmWord: '削除' }
                                                    )

                                                    e.stopPropagation()
                                                    e.preventDefault()
                                                }}
                                            >
                                                転記取消
                                            </Button>
                                        </TableCell>

                                        <TranscriptionHistoryTableData
                                            transcriptionHistory={transcriptionHistory}
                                            displaySetting={transcriptionHistoryDisplaySetting}
                                        />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                </>
            </ContentBody>
            <FixedFooter open={multipleCheckForm.form.object.items.length > 0}>
                {(() => {
                    if (!multipleCheckForm.form.object.items[0]) {
                        return
                    }
                    const vm = new TranscriptionHistoryViewModel(multipleCheckForm.form.object.items[0] as TranscriptionHistory)
                    return (
                        <Button
                            onClick={() => {
                                props.history.push(`${vm.getPath()}?TranscriptionHistoryIdIn=${multipleCheckForm.ids().join(',')}`)
                            }}
                        >
                            転記した{vm.getPath()}をすべて表示
                        </Button>
                    )
                })()}
            </FixedFooter>
        </>
    )
}

export default withRouter(TranscriptionHistoriesPage)
